import { useMemo } from 'react'
import { useUnifiedBilling, refreshBilling } from './global-billing'
import type { SubscriptionInfo } from '@highlight/common/types'

export type { SubscriptionInfo }

/**
 * Hook to get subscription information.
 */
export const useSubscription = () => {
  const billingState = useUnifiedBilling()

  const subscription: SubscriptionInfo = useMemo(() => {
    return billingState.subscription
  }, [billingState.subscription])

  return {
    subscription,
    billingProfile: billingState.billingProfile,
    isSubscriptionLoading: billingState.paywall.isLoading,
    isSubscriptionFetching: billingState.paywall.isLoading,
    refetchSubscription: refreshBilling,
  }
}
